import {_, Component, Container, Link, React} from 'utils';
import { App, Creators, FairStore, SuperfairStore } from 'model';
import Countdown from "react-countdown";
import './countdowntime.less';

class CountdownTime extends Component {

	static getStores() {
		return [FairStore, SuperfairStore];
	}

	static calculateState() {
		return {
			fairData: FairStore.getFairData(),
		}
	}

	render() {
		var stopwatchUrl = App.resourceUrl('stopwatch.svg');

		let { fairData } = this.state;

		let end = new Date(fairData.endsAt).getTime();

        if (end < Date.now()) {
            return null;
        }

		return <div className="countdown">
			<div className="content">
				<img alt={_('Time Left')} src={stopwatchUrl}/>
        <Countdown date={end} />
			</div>
    </div>;
	}
}

export default Container.create(CountdownTime);



// WEBPACK FOOTER //
// ./src/modules/components/countdowntime.js